// extracted by mini-css-extract-plugin
export default {"title":"TeamPhoto_title__GrK3j","subtitle":"TeamPhoto_subtitle__VdvF-","photo":"TeamPhoto_photo__7-BBJ","photoContainer":"TeamPhoto_photoContainer__ugYnL"};